/* eslint-disable class-methods-use-this */ import { SocketLobbySend } from '../../../shared/scripts/socket/SocketLobbySend.ts';
import { UIManagerEvents } from '../../../shared/scripts/ui_html/UIManagerEvents.ts';
import { UIWAdController } from '../ui_ad/UIWAdController.ts';
import { Scene } from './UISceneTypes.ts';
import { getHomepageUrlWithParameter, navigateToPage } from '../../../shared/scripts/ui_utils/ClientUtils.ts';
export class UIWManagerEvents extends UIManagerEvents {
    async createClickedJoinRoomCallback(gameId) {
        var _this_uiManager;
        var _this_uiManager_adController_adblockState_isAdblockActive;
        await UIWAdController.initiatePopupActionFromUserState((_this_uiManager_adController_adblockState_isAdblockActive = (_this_uiManager = this.uiManager) === null || _this_uiManager === void 0 ? void 0 : _this_uiManager.adController.adblockState.isAdblockActive) !== null && _this_uiManager_adController_adblockState_isAdblockActive !== void 0 ? _this_uiManager_adController_adblockState_isAdblockActive : false);
        await SocketLobbySend.clickedJoinRoom(gameId);
    }
    isSceneLobby() {
        var _this_uiManager;
        return ((_this_uiManager = this.uiManager) === null || _this_uiManager === void 0 ? void 0 : _this_uiManager.sceneController.scene) != Scene.Lobby;
    }
    isSceneGame() {
        var _this_uiManager;
        return ((_this_uiManager = this.uiManager) === null || _this_uiManager === void 0 ? void 0 : _this_uiManager.sceneController.scene) == Scene.Game;
    }
    leaveRoomAndJoinRoom(roomId) {
        navigateToPage(`#${roomId}`, false);
    }
    performRoomLeavingAction(action) {
        action();
    }
    handleUrlRedirectViaParameters(parameter, parameterValue) {
        navigateToPage(getHomepageUrlWithParameter(parameter, parameterValue));
    }
    premiumMembershipCheckAction() {
        if (this.showSubscriptionOverlayIfVariant()) return;
        navigateToPage('/store#membership', true);
    }
    cancelMatchmakingSearch() {
        var _this_uiManager;
        (_this_uiManager = this.uiManager) === null || _this_uiManager === void 0 ? void 0 : _this_uiManager.matchmakingController.stopSearching();
    }
    shareImage(title, text, link, imageFile, imageSrc) {
        return;
    }
    constructor(uiManager){
        super();
        this.uiManager = uiManager;
    }
}
